import illustrator from '../../assets/stacklogo/illustrator.svg';

export default function Illustrator(){
    return(
        <img src={illustrator} alt="" srcset="" />
    )
}